import { LOCALE_ID, NgModule } from "@angular/core";
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { ReuniaoRoutes } from "./reuniao.routing";
import { ReunioesResolver } from "./resolver/reunioes.resolver";
import { ReunioesService } from "./services/reunioes.service";
import { ReunioesListComponent } from "./components/reunioes-list/reunioes-list.component";
import { CommonModule, registerLocaleData } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from "src/app/shared/shared.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { PautaService } from "./services/pauta.service";
import { PautaResolver } from "./resolver/pauta.resolver";
import { PautaEditComponent } from "./components/pauta-edit/pauta-edit.component";
import { GlobalErrorHandlerService } from "src/app/shared/services/global-error-handler.service";
import { ItensService } from "./services/itens.service";
import { ItensResolver } from "./resolver/itens.resolver";
import { ItensEditComponent } from "./components/itens-edit/itens-edit.component";
import { NgChartsModule } from "ng2-charts";
import { ItensCriticalActionsComponent } from "./components/itens-critical-actions/itens-critical-actions.component";
import { ItensCheckCriticalComponent } from "./components/itens-check-critical/itens-check-critical.component";
import { ItensPfIndicatorsComponent } from "./components/itens-pf-indicators/itens-pf-indicators.component";
import { ItensAcPfComponent } from "./components/itens-ac-pf/itens-ac-pf.component";
import { ItensAcProjectsComponent } from "./components/itens-ac-projects/itens-ac-projects.component";
import { ItensAcPrtIssuesComponent } from "./components/itens-ac-prt-issues/itens-ac-prt-issues.component";
import { ItensAcIndicatorsComponent } from "./components/itens-ac-indicators/itens-ac-indicators.component";
import { ItensIndActionComponent } from "./components/itens-ind-action/itens-ind-action.component";
import { OrdemEditComponent } from "./components/ordem-edit/ordem-edit.component";
import { OrdemService } from "./services/ordem.service";
import { OrdemResolver } from "./resolver/ordem.resolver";
import { ItensListComponent } from "./components/itens-list/itens-list.component";
import { AnexosListComponent } from "./components/anexos-list/anexos-list.component";
import { AnexosService } from "./services/anexos.service";
import { AnexosResolver } from "./resolver/anexos.resolver";
import { AnexosEditComponent } from "./components/anexos-edit/anexos-edit.component";
import { ParticipantesEditComponent } from "./components/participantes-edit/participantes-edit.component";
import { ParticipantesListComponent } from "./components/participantes-list/participantes-list.component";
import { ParticipantesResolver } from "./resolver/participantes.resolver";
import { ParticipantesService } from "./services/participantes.service";
import { NavTabsComponent } from "./components/nav-tabs/nav-tabs.component";
import { ApresentacaoPautaComponent } from "./components/apresentacao-pauta/apresentacao-pauta.component";
import { ApresentacaoService } from "./services/apresentacao.service";
import { ApresentacaoCombosResolver } from "./resolver/apresentacao.resolver";
import { OrdemDropComponent } from "./components/ordem-drop/ordem-drop.component";
import { NavTabsApresentacaoComponent } from "./components/nav-tabs-apresentacao/nav-tabs-apresentacao.component";
import { ApresentacaoQuadroGeralComponent } from "./components/apresentacao-quadro-geral/apresentacao-quadro-geral.component";
import { ApresentacaoProjetosComponent } from "./components/apresentacao-projetos/apresentacao-projetos.component";
import { ApresentacaoSlideComponent } from "./components/apresentacao-slide/apresentacao-slide.component";
import { ApresentacaoSlideModalComponent } from "./components/apresentacao-slide-modal/apresentacao-slide-modal.component";
import { ApresentacaoRegistroComponent } from "./components/apresentacao-registro/apresentacao-registro.component";
import { ApresentacaoDemandasComponent } from "./components/apresentacao-demandas/apresentacao-demandas.component";
import { ApresentacaoAnexosComponent } from "./components/apresentacao-anexos/apresentacao-anexos.component";
import { SharedService } from "./services/shared.service";
import { ThumbnailFilesListComponent } from "src/app/shared/components/thumbnail-files-list/thumbnail-files-list.component";
import { ApresentacaoFiltroComponent } from "./components/apresentacao-filtro/apresentacao-filtro.component";
import { ApresentacaoRelatorioComponent } from "./components/apresentacao-relatorio/apresentacao-relatorio.component";
import { AdminEditComponent } from "./components/admin-edit/admin-edit.component";
import { AdminService } from "./services/admin.service";
import { AdminResolver } from "./resolver/admin.resolver";
import { AdminListComponent } from "./components/admin-list/admin-list.component";
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ReuniaoRoutes,
        NgSelectModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        SharedModule,
        NgChartsModule,
        BsDatepickerModule,
        DragDropModule,
        MatMenuModule,
        MatSelectModule
        
    ],
    exports: [
    ],
    declarations: [
        ReunioesListComponent,
        PautaEditComponent,
        ItensEditComponent,
        ItensCriticalActionsComponent,
        ItensCheckCriticalComponent,
        ItensPfIndicatorsComponent,
        ItensAcPfComponent,
        ItensAcProjectsComponent,
        ItensAcPrtIssuesComponent,
        ItensAcIndicatorsComponent,
        ItensIndActionComponent,
        ItensListComponent,
        OrdemEditComponent,
        OrdemDropComponent,
        AnexosListComponent,
        AnexosEditComponent,
        ParticipantesEditComponent,
        ParticipantesListComponent,
        NavTabsComponent,
        NavTabsApresentacaoComponent,
        ApresentacaoPautaComponent,
        ApresentacaoQuadroGeralComponent,
        ApresentacaoProjetosComponent,
        ApresentacaoRegistroComponent,
        ApresentacaoSlideComponent,
        ApresentacaoSlideModalComponent,
        ApresentacaoDemandasComponent,
        ApresentacaoAnexosComponent,
        ThumbnailFilesListComponent,
        ApresentacaoFiltroComponent,
        ApresentacaoRelatorioComponent,
        AdminListComponent,
        AdminEditComponent
    ],
    providers: [
        ReunioesService,
        ReunioesResolver,
        PautaService,
        PautaResolver,
        ItensService,
        ItensResolver,
        OrdemService,
        OrdemResolver,
        AnexosService,
        AnexosResolver,
        ParticipantesService,
        ParticipantesResolver,
        ApresentacaoService,
        ApresentacaoCombosResolver,
        AdminService,
        AdminResolver,
        SharedService,
        { provide: LOCALE_ID, useValue: 'pt-BR' }
    ],
  })
  export class ReuniaoModule { }